import React from "react";
import { requireAuth } from "../util/auth";
import { Container } from "@material-ui/core";
import CreatePromptForm from "../components/CreatePromptForm";
import ListPrompts from "../components/ListPrompts";

function PromptsPage() {
  return (
    <Container maxWidth="md">
      <h1>My Prompts</h1>
      <CreatePromptForm />
      <ListPrompts />
    </Container>
  );
}

export default requireAuth(PromptsPage);
